export default {
  scrollerColor: Styles.color.grey.one,
  scrollerWrapperColor: Styles.color.grey.eight,
};
